import { Capacitor } from "@capacitor/core";
import { checkNotificationsPermission } from "./notifications";
import {
  pauseWorkout,
  togglePlayerOnlineStatus,
  confirmEndWorkout,
} from "./workout-player";
import { TypeKeys } from ".";
import {
  getGymPassIdFromUserDoc,
  logGympassAnalytics,
} from "../global/gympass";

import { App, AppState } from "@capacitor/app";
import { Network } from "@capacitor/network";
// import { checkWorkoutLogsToRead } from './health';
import {
  AppUpdate,
  AppUpdateAvailability,
  FlexibleUpdateInstallStatus,
  FlexibleUpdateState,
} from "@capawesome/capacitor-app-update";
import { AlertOptions, alertController } from "@ionic/core";
import { translate } from "../global/translate";
import { getAvailableNativeHealthApps } from "../actions-stencil-store/health";
// import healthIntegration from "../stencil-store/health.store";

export const listenToAppStateChange = () => async (dispatch, getState) => {
  if (Capacitor.isNativePlatform()) {
    App.addListener("appStateChange", (state: AppState) => {
      if (!state.isActive) {
        return dispatch(pauseWorkout());
      } else {
        // 1. app goes inactive while prompting for permission
        // 2. also if user goes to settings and comes back to app - check permissions again
        dispatch(checkNotificationsPermission());
        // dispatch(checkWorkoutLogsToRead()); //todohealth replace
        getAvailableNativeHealthApps();

        const { user } = getState() as SworkitState;
        const gymPassId = getGymPassIdFromUserDoc(user);
        logGympassAnalytics(gymPassId, "signin");
      }
    });
  } else {
    const { user } = getState() as SworkitState;
    const gymPassId = getGymPassIdFromUserDoc(user);
    logGympassAnalytics(gymPassId, "signin");
  }
  if (Capacitor.getPlatform() === "android") {
    App.addListener("backButton", () => dispatch(handlebackButton()));
    AppUpdate.addListener(
      "onFlexibleUpdateStateChange",
      (state: FlexibleUpdateState) => {
        if (state.installStatus === FlexibleUpdateInstallStatus.DOWNLOADED) {
          completeFlexibleUpdate();
        }
      },
    );
    startFlexibleUpdate();
  }
  try {
    const { connected } = await Network.getStatus();
    dispatch(toggleOnline(connected));
    await Network.addListener("networkStatusChange", (status) => {
      const connected = status.connected;
      dispatch(toggleOnline(connected));
      togglePlayerOnlineStatus(connected);
    });
  } catch (err) {
    console.debug("networkStatusChange error", err);
  }
};

export interface ToggleOnline {
  type: TypeKeys.TOGGLE_ONLINE;
  online: boolean;
}

function toggleOnline(online: boolean) {
  const action: ToggleOnline = {
    type: TypeKeys.TOGGLE_ONLINE,
    online,
  };
  return action;
}
const startFlexibleUpdate = async () => {
  const result = await AppUpdate.getAppUpdateInfo();
  if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
    return;
  }
  if (result.flexibleUpdateAllowed) {
    await AppUpdate.startFlexibleUpdate();
  }
};

const completeFlexibleUpdate = async () => {
  const options: AlertOptions = {
    subHeader: translate("UPDATE_READY_RESTART_NOW"),
    buttons: [
      {
        text: translate("DISMISS"),
        role: "cancel",
        handler: () => {
          AppUpdate.removeAllListeners();
        },
      },
      {
        text: translate("YES"),
        handler: () => {
          AppUpdate.completeFlexibleUpdate();
          AppUpdate.removeAllListeners();
        },
      },
    ],
  };
  const alert = await alertController.create(options);
  return alert.present();
};

const handlebackButton = () => async (dispatch, getState) => {
  const {
    ui: { toRoute },
  } = getState() as SworkitState;
  const modalCtrl = document.querySelector("ion-modal");
  if (modalCtrl) {
    const modalWasClosed = await modalCtrl.dismiss();
    if (modalWasClosed) return;
  }
  const alertCtrl = document.querySelector("ion-alert");
  if (alertCtrl) {
    const alertWasClosed = await alertCtrl.dismiss();
    if (alertWasClosed) return;
  }
  const menuCtrl = document.querySelector("ion-menu");
  const menuWasClosed = await menuCtrl.close();
  if (menuWasClosed) return;
  if (isMenuRoute(toRoute)) {
    document.querySelector("ion-router").push("/", "root");
    return;
  }
  if (isHome(toRoute)) {
    App.exitApp();
  }
  if (isEndWorkout(toRoute)) {
    document.querySelector("ion-router").push("/", "root");
    return;
  }
  if (isWorkoutPage(toRoute)) {
    dispatch(confirmEndWorkout());
    return;
  }
  return document.querySelector("ion-router").back();
};

function isHome(toRoute: string) {
  return toRoute == "/";
}

function isMenuRoute(toRoute: string) {
  const routes = [
    "/my-sworkit",
    "/goals",
    "/custom",
    "/my-sworkit",
    "/reminders",
    "/exercise-library",
    "/account",
    "/help",
    "/settings",
  ];
  const isMenu = routes.indexOf(toRoute) !== -1;
  return isMenu;
}

function isEndWorkout(toRoute: string) {
  return toRoute.includes("end-workout");
}

function isWorkoutPage(toRoute: string) {
  return toRoute.includes("/player/");
}
